export const RECEPTION_FEEDBACK_SESSION_KEY = 'sos_reception_feedback_active_v1';
export const RECEPTION_FEEDBACK_SESSION_EVENT = 'sos-reception-feedback-session-updated';
export const RECEPTION_FEEDBACK_STORAGE_KEY = 'sos_reception_feedback_v1';
export const RECEPTION_FEEDBACK_UPDATED_EVENT = 'sos-reception-feedback-updated';

let activeReception = null;
const ratedReceptionIds = new Set();

export function readActiveReceptionFeedback() {
  return activeReception;
}

export function readRatedReceptionIds() {
  return new Set(ratedReceptionIds);
}

export function announceReceptionFeedback(reception) {
  const session = { ...reception, type: 'TIEP_DAN', announcedAt: new Date().toISOString() };
  activeReception = session;
  window.dispatchEvent(new CustomEvent(RECEPTION_FEEDBACK_SESSION_EVENT, { detail: session }));
  return session;
}

export function clearReceptionFeedback() {
  activeReception = null;
  window.dispatchEvent(new CustomEvent(RECEPTION_FEEDBACK_SESSION_EVENT, { detail: null }));
}
